import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

// import TestResult from "./TestResult";
import { Route, Routes, Navigate } from "react-router-dom";
import coin from "../../assets/coin.webp";
// import Profile from "./Profile";
// import ChangePassword from "./ChangePassword";
import { useContext } from "react";
// import CreateQuestion from "./CreateQuestion";
// import SamplePaper from "./SamplePaper.jsx";
// import ProgressReport from "./ProgressReport.jsx";
// import ReferEarn from "./ReferEarn.jsx";

import CreateQuestion from "./CreateQuestion";
import SamplePaper from "./SamplePaper";
import QuestionList from "./QuestionList";
import ExamList from "./ExamList";
import Result from "./Result";
import SyncOfflinePage from "./SyncOfflinePage";
import AdminSidebar from "../../components/AdminSidebar";
import DomainManagement from "./DomainManagement";
import useUserStore from "../../stores/useUserStores";

const AdminDashboard = ({ side, handleside }: any) => {
  const { userdetail } = useUserStore();
  const [cc, setcc] = useState(0);
  const location = useLocation();
  // const [side, setside] = useState(true);

  useEffect(() => {
    // setcc(userdetail.elitecoin);
  }, [userdetail]);

  return (
    <>
      <section id="sidebar-section" className="flex justify-center relative">
        <div
          className={
            side
              ? "absolute top-0 left-0 w-full h-full flex justify-center items-center z-10 backdrop-blur-sm lg:backdrop-blur-none"
              : ""
          }
          onClick={handleside}
        ></div>
        {userdetail && userdetail.userType !== "TCADMIN" ? (
          <AdminSidebar side={side} handleside={handleside} />
        ) : (
          <></>
        )}

        <section id="" className=" w-full min-h-screen overflow-y-scroll">
          <Routes>
            <Route path="/question-bank" element={<QuestionList />} />
            <Route path="/create-question" element={<CreateQuestion />} />
            <Route path="/create-test" element={<SamplePaper />} />
            <Route path="/test-list" element={<ExamList />} />
            <Route path="/result" element={<Result />} />
            <Route path="/domain-management" element={<DomainManagement />} />
            {userdetail && userdetail.userType === "TCADMIN" ? (
              <Route path="/" element={<SyncOfflinePage />} />
            ) : (
              <></>
            )}
          </Routes>
        </section>
      </section>
    </>
  );
};

export default AdminDashboard;
